import { Route, createRoutesFromElements } from "react-router";
import { createBrowserRouter } from "react-router-dom";
import PrivateRoute from "../helpers/PrivateRoute";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import HomePage from "../pages/Homepage";
import RootLayout from "../components/layout/RootLayout";
import PageNotFound from "../pages/error/PageNotFound";
import Plans from "../pages/Plans";
import Business from "../pages/Business";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import ChangePassword from "../pages/ChangePassword";
import Memberships from "../pages/memberships";
import Members from "../pages/member";
import Attendance from "../pages/attendance";
import StaffAttendance from "../pages/staff-attendance";
import BusinessPayments from "../pages/business-payments";
import MemberPayments from "../pages/member-payments";
import Messages from "../pages/messages";
import Users from "../pages/users";
import BiometricUsers from "../pages/biometric-users";
import ApplicationError from "../pages/error/ApplicationError";
import Billing from "../pages/billing";
import Settings from "../pages/settings";
import Notes from "../pages/notes";
import Products from "../pages/store/products";
import Sales from "../pages/store/sales";
import MemberQrActions from "../pages/qr/member-qr-actions";
import NutritionPlanBuilder from "../pages/nutrition-plan-builder";
import MemberNutrition from "../pages/member-nutrition";
import BiometricTransactions from "../pages/biometric-transactions";
import MealItems from "../pages/meal-items";
import WorkoutPlanBuilder from "../pages/workout-plan-builder";
import MemberWorkout from "../pages/member-workout";
import Exercises from "../pages/exercises";
import Permissions from "../pages/permissions";
import Profile from "../pages/profile";
import BiometricDevices from "../pages/biometric-device";


export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<HomePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/plans"
        element={
          <PrivateRoute>
            <Plans />
          </PrivateRoute>
        }
      />
      <Route
        path="/business"
        element={
          <PrivateRoute>
            <Business />
          </PrivateRoute>
        }
      />
      <Route
        path="/memberships"
        element={
          <PrivateRoute>
            <Memberships />
          </PrivateRoute>
        }
      />
      <Route
        path="/members"
        element={
          <PrivateRoute>
            <Members />
          </PrivateRoute>
        }
      />
      <Route
        path="/devices"
        element={
          <PrivateRoute>
            <BiometricDevices />
          </PrivateRoute>
        }
      />
      <Route
        path="/devices/:deviceId/users"
        element={
          <PrivateRoute>
            <BiometricUsers />
          </PrivateRoute>
        }
      />
      <Route
        path="/devices/:deviceId/transactions"
        element={
          <PrivateRoute>
            <BiometricTransactions />
          </PrivateRoute>
        }
      />
      <Route
        path="/attendance"
        element={
          <PrivateRoute>
            <Attendance />
          </PrivateRoute>
        }
      />
      <Route
        path="/messages"
        element={
          <PrivateRoute>
            <Messages />
          </PrivateRoute>
        }
      />
      <Route
        path="/products"
        element={
          <PrivateRoute>
            <Products />
          </PrivateRoute>
        }
      />
      <Route
        path="/sales"
        element={
          <PrivateRoute>
            <Sales />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/staff-attendance"
        element={
          <PrivateRoute>
            <StaffAttendance />
          </PrivateRoute>
        }
      />
      <Route
        path="/permissions"
        element={
          <PrivateRoute>
            <Permissions />
          </PrivateRoute>
        }
      />
      <Route
        path="/business-payments"
        element={
          <PrivateRoute>
            <BusinessPayments />
          </PrivateRoute>
        }
      />
      <Route
        path="/member-payments"
        element={
          <PrivateRoute>
            <MemberPayments />
          </PrivateRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <PrivateRoute>
            <Billing />
          </PrivateRoute>
        }
      />
      <Route
        path="/members/:memberId/nutrition-plan"
        element={
          <PrivateRoute>
            <NutritionPlanBuilder />
          </PrivateRoute>
        }
      />
      <Route
        path="/members/:memberId/workout-plan"
        element={
          <PrivateRoute>
            <WorkoutPlanBuilder />
          </PrivateRoute>
        }
      />
      <Route
        path="/notes"
        element={
          <PrivateRoute>
            <Notes />
          </PrivateRoute>
        }
      />
      <Route
        path="/member/nutrition"
        element={
          <PrivateRoute>
            <MemberNutrition />
          </PrivateRoute>
        }
      />
      <Route
        path="/member/workout"
        element={
          <PrivateRoute>
            <MemberWorkout />
          </PrivateRoute>
        }
      />
      <Route
        path="/meal-items"
        element={
          <PrivateRoute>
            <MealItems />
          </PrivateRoute>
        }
      />
      <Route
        path="/exercises"
        element={
          <PrivateRoute>
            <Exercises />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route path="/qr">
        <Route
          path="member/:qrToken"
          element={<MemberQrActions />}
        />
      </Route>
      <Route
        path="/change-password"
        element={
          <PrivateRoute>
            <ChangePassword />
          </PrivateRoute>
        }
      />
      <Route
        path="/application-error"
        element={
          <PrivateRoute>
            <ApplicationError />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  )
)